import styles from "./SIPCalculator.module.css";
const formatIN = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
  return Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
const ResultCard = ({
  result,
  stepUpResult
}) => {
  return (
    <>
      {result && (
        <>
          <div className={styles.resultCard}>
            <div className={styles.resultRow}>
              <span>Total Savings till Retirement:</span>
              <strong>₹ {formatIN(result.totalInvested)}</strong>
            </div>

            <div className={styles.resultRow}>
              <span>Amount on Maturity:</span>
              <strong>₹ {formatIN(result.FV)}</strong>
            </div>

            <div className={styles.resultRow}>
              <span>Amount on Maturity ₹Crores:</span>
              <strong>{formatIN(result.FVInCrores)}</strong>
            </div>
          </div>
        </>
      )}

      {stepUpResult && (
        <div className={styles.resultCard}>
          <h3 className={styles.resultsTitle}>Returns with SIP Step-up</h3>

          <div className={styles.heroAmount}>
            ₹ {formatIN(stepUpResult.withStepUp.amountOnMaturity)}
          </div>

          <div className={styles.toggleGroup}>
            <div className={styles.non_highlight}>
              Without Step-Up
            </div>

            <div className={styles.highlight}>
              <svg
                className={styles.checkIcon}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="white"
                  strokeWidth="1.5"
                />
                <path
                  d="M6 10.5L8.5 13L14 7"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              With Step-Up
            </div>
          </div>

          <div className={styles.statsGrid}>
            <div className={styles.statColumn}>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Total Savings till Retirement
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withoutStepUp.totalSavingsTillRetirement
                  )}
                </span>
              </div>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Amount on Maturity
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withoutStepUp.amountOnMaturity
                  )}
                </span>
              </div>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Amount on Maturity ₹Crores
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withoutStepUp.amountOnMaturityCrores
                  )}
                </span>
              </div>
            </div>

            <div className={styles.statColumn}>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Total Savings till Retirement
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withStepUp.totalSavingsTillRetirement
                  )}
                </span>
              </div>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Amount on Maturity
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withStepUp.amountOnMaturity
                  )}
                </span>
              </div>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>
                  Amount on Maturity ₹Crores
                </span>
                <span className={styles.statValue}>
                  ₹{" "}
                  {formatIN(
                    stepUpResult.withStepUp.amountOnMaturityCrores
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultCard;